import {customElement, bindable} from 'aurelia-framework';

@customElement('sio-layout-column')
export class LayoutColumn
{
    @bindable() mdColumn       = 6;
    @bindable() bootstrapClass = 'col-xs-12 col-md-' + this.mdColumn;
}